export default __webpack_public_path__ + "static/media/icons-empty-domain.721b8e83.png";